
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
    @Prop({ default: 'primary' }) color!: string;
    @Prop({ default: null }) bgColor!: string;
    @Prop({ default: false }) text!: boolean;
    @Prop({ default: false }) loading!: boolean;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) outlined!: boolean;
    @Prop({ default: null }) minWidth!: string;
    @Prop({ default: false }) fullWidth!: boolean;
    @Prop({ default: true }) uppercase!: boolean;
    @Prop({ default: '' }) tooltipText!: string; // Texto para el tooltip

    @Emit()
    handleClick() {}
}
